import { NgModule } from '@angular/core';
import { HomeApplication } from './service/home.application';
import { HomeInfructureLayerModule } from '../infrustructure/home-infrustructre.module';
import { HomeDomainLayerModule } from '../domain/home-domain.module';
import { SlideshowApplication } from './service/slideshow.application';

@NgModule({
  providers: [HomeApplication, SlideshowApplication],
  imports: [HomeInfructureLayerModule, HomeDomainLayerModule],
  exports: [],
})
export class HomeApplicationModule {}
